module.exports = __webpack_public_path__ + "static/material-fabric.7585aac1.svg";